import VideoUploadSection, { VideoUploadSectionProps } from './VideoUploadSection';

export type { VideoUploadSectionProps };
export default VideoUploadSection;
